import { Injectable } from "@angular/core";
import { AbstractControl, AsyncValidatorFn, ValidationErrors } from "@angular/forms";
import { catchError, map, Observable, of, switchMap, timer } from "rxjs";
import { HelperMethods } from "src/app/shared/helper-methods";
import { PartnerService } from "./partner.service";

@Injectable({
  providedIn: "root",
})
export class ValidatorService {
  constructor(private _partnerService: PartnerService) {}

  validatePartnerId(): AsyncValidatorFn {
    return (control: AbstractControl): Promise<ValidationErrors | null> | Observable<ValidationErrors | null> => {
      if (!control.value.toString().match(/^\d+$/)) {
        return !control.value ? of({ required: true }) : of({ partnerId: "Partner id invalid" });
      }

      return timer(500).pipe(
        switchMap(() => {
          return this._partnerService.validatePartnerId$(parseInt(control.value)).pipe(
            map(response => {
              control.parent.get("partnerName").setValue(response);
              return null;
            }),
            catchError(err => {
              const errors = HelperMethods.getResponseErrors(err, false);
              control.parent.get("partnerName").setValue(null);
              return of({ partnerId: errors.length ? errors[0] : "Failed, try again" });
            }),
          );
        }),
      );
    };
  }
}
